<template>
  <div class="coupon">
    <div class="navtab">
      <div v-for="(item,index) in navlist" :key="index" :class="curnav==index?'navitem active':'navitem'" @click="navtab(index)">{{item.key}}</div>
    </div>
    <scroll :data="couponlist" class="coupon_content" :pulldown="true" @onPullDownRefresh="onPullDownRefresh" :scrollY="true" :listenScroll="true">
    <div class="contain">
    <div class="list" v-for="(item,index) in couponlist" :key="index" v-if="(curnav==0&&!item.IsExpired)||(curnav==1&&item.IsExpired)">
      <div :class="item.OfferSetting.PreferentialMode==2?'blue info':item.IsExpired==true?'info dark':'info'">
        <div class="left">
          <!-- <div class="price"><span>¥</span>{{item.OfferSetting.DeductInfo.CutAmount}}</div> -->
          <div class="price" v-if="item.OfferSetting.PreferentialMode == 1 || item.OfferSetting.PreferentialMode == 3"><span>¥</span>
            {{item.OfferSetting.DeductInfo.CutAmount}}
          </div>
          <div class="price" v-if="item.OfferSetting.PreferentialMode == 2">
            {{(item.OfferSetting.DeductInfo.DiscountRate * 10).toFixed(1)}}<span>折</span>
          </div>
          <div>{{item.OfferSetting.PreferentialMode == 1 || item.OfferSetting.PreferentialMode == 3?'满减券':item.OfferSetting.PreferentialMode==2?'折扣券':'抵现券'}}</div>
        </div>
        <div class="right">
          <div class="top">
            <div class="txt">
              <div class="tit">{{item.Name}}</div>
              <div class="time">{{item.ValidDateStart.split("T")[0].replace(/\-/g, '\.')+'-'+item.ValidDateEnd.split("T")[0].replace(/\-/g, '\.')}}</div>
            </div>
             <div class="btn" @click="gorent">立即使用</div>
            <!-- <div class="btn" @click="drawcoup(item.CanDrawCoupon,item.OfferID)" v-if="false">立即领取</div> -->
          </div>
          <div class="bottom" @click="detailInfo(index)">
            <div class="txt">详细信息</div>
            <div class="icon"></div>
          </div>
        </div>
      </div>
      <div class="detail" v-if="isShow[index]">
        <div class="txt">{{item.OfferSetting.Comments}}</div>
      </div>
    </div>
    <div class="nodata" v-if="nocoupon">
      <p>没有数据哦~</p>
    </div>
   </div>
   </scroll>
    <div class="bottombtn" @click="gomore()">领更多好券</div>
  </div>
</template>
<script>
import { getConsumerCoupons,DrawCoupon } from '@/utils/api'
import { resourceUrl,orderSource} from "@/utils/env";
import scroll from "@/components/scroll.vue";

export default {
  name: "couponlist",
  data() {
    return {
      curnav:0,
      navlist:[{
        key:'未使用',
        value:'1',
      },{
        key:'已过期',
        value:'2',
      }],
      isShow:[],
      couponlist:[],
      nocoupon:true
    };
  },
  props: [],
  components:{
    scroll
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background:#fff')
    // document.querySelector('html').setAttribute('style', 'height:100%')
  },
  created(){
  },
  beforeDestroy () {
    document.querySelector('body').setAttribute('style', 'background:#f2f2f2')
  },
  mounted(){
    this.init();
  },
  methods: {
    async init(){
      // let that = this;
      setTimeout(async ()=>{
        let res = await getConsumerCoupons({
          data:{
            bizType:1,
            loadAllCoupon:true,
            isGetExpired:true
          },
          isLoading: 1
        });
        if(res.Code==100){
          this.couponlist=res.Data;
          for(let i=0;i<res.Data.length;i++){
            this.isShow.push(false);
          }
          this.isnocoupon(this.curnav,res.Data);
        }
      },200)
    },
    navtab(index){
      this.curnav=index;
      this.isnocoupon(index,this.couponlist);
    },
    gorent(){
      let userAgent = navigator.userAgent;
      if ( /DFZCFlutterAPPAndroid/.test(userAgent) ) {
        window.goHome.postMessage('');
        return;
      }
      if(orderSource==17){
        window.webkit.messageHandlers.goHome.postMessage(null);
      }else if(orderSource==16){
        window.dfpanda.goHome();
      }
    },
    detailInfo(index){
      let show=this.isShow[index];
      this.$set(this.isShow, index, !show)
    },
    gomore(){
      let userAgent = navigator.userAgent;
      if ( /DFZCFlutterAPPAndroid/.test(userAgent) ) {
        window.openPage.postMessage(JSON.stringify({type: 'html', url: 'https://cms.dafang24.com/activity/pages/coupons.html'}));
        return;
      }
      this.$router.push({path:"/activity"})
    },
    onPullDownRefresh() {
      this.couponlist = [];
      this.init();
    },
    isnocoupon(cur,arr){
      let _that = this;
      for(var i=0;i<arr.length;i++){
        if(cur==0){
          if(arr[i].IsExpired==false){
            _that.nocoupon = false;
            return;
          }else{
            _that.nocoupon = true;
          }
        }else if(cur==1){
          if(arr[i].IsExpired==true){
            _that.nocoupon= false;
            return
          }else{
             _that.nocoupon= true;
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped type="text/scss">
.coupon {
  width:100%;
  height:100vh;
  background:#fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  color:#434343;

  .navtab{
    width:100%;
    display: flex;
    align-items: center;
    color:#434343;
    font-size: 26px;
    margin-bottom:47px;
    .navitem{
      width:50%;
      height:80px;
      line-height: 80px;
      text-align: center;
      position: relative;
    }
    .navitem::after{
      content: '';
      display: block;
      width:40px;
      height:8px;
      position: absolute;
      left:50%;
      bottom:0;
      margin-left:-20px;
      border-radius: 4px;
      background:transparent;
    }
    .navitem.active::after{
      background:#FF8307;
    }
  }
  .coupon_content{
    flex:1;
    overflow: hidden;
  }

  .list{
    width:680px;
    background:#fff;
    margin-bottom:25px;
    font-size: 26px;
    .info{
      width:100%;
      height:170px;
      background:url(~@/assets/images/coupon_listbg01.png) no-repeat center;
      background-size: contain;
      display: flex;
      .left{
        width:200px;
        height:170px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color:#fff;
        text-align: center;
        .price{
          font-size: 70px;
          span{
            font-size: 26px;
          }
        }
      }
      .right{
        font-size: 26px;
        width:480px;
        height:170px;
        padding:0 23px 0 18px;
        .top{
          height: 125px;
          border-bottom:1px solid #e2e2e2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .time{
            font-size: 18px;
          }
          .btn{
            width:125px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border:1px solid #FF8307;
            color:#FF8307;
            border-radius: 20px;
            font-size: 22px;
          }
          .btn.blue{
            border:1px solid #1D8EFF;
            color:#1D8EFF;
          }
        }
        .bottom{
          height:45px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color:#999999;
          font-size: 18px;
          .icon{
            width: 0;
            height:0;
            border-left: 8px solid transparent;
            border-right:8px solid transparent;
            border-top: 10px solid #000;
          }

        }
      }
    }
    .info.blue{
      background:url(~@/assets/images/coupon_listbg02.png) no-repeat center;
      background-size: contain;
    }
    .info.dark{
      background:url(~@/assets/images/coupon_listbg03.png) no-repeat center;
      background-size: contain;
      color:#999;
      .right .top .btn{
        display:none;
        border: 1px solid #999;
        color: #999;
      }
      .right .bottom .icon{
        border-top: 10px solid #999;
      }
    }
    .detail{
      border:1px solid #e2e2e2;/**no**/
      border-top:none;
      padding:20px 30px;
      font-size: 18px;
      color:#999999;
    }
  }
  .bottombtn{
    // position: absolute;
    // bottom:65px;
    width:600px;
    height: 90px;
    line-height: 90px;
    border-radius: 45px;
    background:#FF8307;
    color:#fff;
    text-align: center;
    margin:65px 0;
  }

}
</style>
